import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
export type TilesFragment = { __typename?: 'categories', tile_row_collection?: { __typename?: 'TileRowCollection', id: string, SeeMoreViewAll?: boolean | null, Width?: string | null, internal_name?: string | null, half_width_tile?: { __typename?: 'HalfWidthTileBlock', type?: string | null } | null, first_full_width_tile?: { __typename?: 'TileBlock', type?: string | null } | null, second_full_width_tile?: { __typename?: 'TileBlock', type?: string | null } | null, third_full_width_tile_block?: { __typename?: 'TileBlock', type?: string | null } | null } | null };

export const TilesFragmentDoc = gql`
    fragment tiles on categories {
  tile_row_collection {
    id
    SeeMoreViewAll
    Width
    half_width_tile {
      type
    }
    first_full_width_tile {
      type
    }
    second_full_width_tile {
      type
    }
    third_full_width_tile_block {
      type
    }
    internal_name
  }
}
    `;